import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-pt-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-1" }, null, -1)
const _hoisted_3 = { style: {"font-size":"1.2em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Button = _resolveComponent("Button")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_Card = _resolveComponent("Card")!
  const _component_TicketGet = _resolveComponent("TicketGet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, {
      class: "p-shadow-0 p-m-1 p-text-center p-p-3",
      style: {"border":"1px solid gainsboro"}
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$d(_ctx.item.createdAt, "long")), 1)
      ]),
      title: _withCtx(() => [
        _createVNode(_component_Tag, {
          value: _ctx.resume.number,
          icon: `pi pi-${_ctx.resume.icon}`,
          severity: _ctx.resume.color,
          class: "p-text-uppercase",
          style: {"font-size":"14px"}
        }, null, 8, ["value", "icon", "severity"]),
        _createVNode(_component_Button, {
          class: "p-button-sm p-button-raised p-button-rounded p-button-secondary",
          style: {"position":"absolute","right":"5px","top":"43%","z-index":"10","width":"25px","height":"25px"},
          icon: "pi pi-eye",
          type: "button",
          onClick: _ctx.showDetails
        }, null, 8, ["onClick"])
      ]),
      subtitle: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.resume.customer), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_NumberFormatter, {
            value: _ctx.resume.total
          }, null, 8, ["value"]),
          _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
        ])
      ]),
      _: 1
    }),
    (_ctx.visible)
      ? (_openBlock(), _createBlock(_component_TicketGet, {
          key: 0,
          visible: _ctx.visible,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
          id: _ctx.item.id,
          number: _ctx.item.number
        }, null, 8, ["visible", "id", "number"]))
      : _createCommentVNode("", true)
  ], 64))
}